module.exports = __webpack_public_path__ + "img/1500647512.04173600.jpg";